import { ReactElement, ReactNode } from "react";

import { useNoteCurrentRoute } from "./use-note-current-route";

/**
 * Placement is the whole contract:
 *
 *  - Below the auth gate. While `AppShell` and `UserProvider` hold a spinner, the app is walked
 *    across URLs it never renders (app-shell's `_REDIRECT_AFTER_LOGIN_` restore, then Frontegg's hop
 *    to `/`). Above the gate, the recorder would spend the intent on the restore hop and the deep
 *    link would be lost.
 *  - Above the `Outlet`, never beside it. Child effects run before parent effects, so as the parent
 *    this records after `HomeEntryRoute` has read the intent; a sibling rendered before the outlet
 *    would spend it first.
 */
export const RouteMemory = ({ children }: { children: ReactNode }): ReactElement => {
  useNoteCurrentRoute();

  return <>{children}</>;
};
